import {client} from "./ApiClient";
import {mapServiceUrls} from "../Helpers/Globals";
import {useQuery} from "react-query";

const getCustomerCoupons = (key, urls, accessKey, uid) => {
    return client(urls.LoyaltyEngineApiUrl, `api/v4/${accessKey}/Customers/availableCoupons?uid=${uid}`)
}

export default function useCustomerCoupons(urls, accessKey, uid) {
    const {status, data, error, refetch } = useQuery(['customerCoupons', uid], (key) => getCustomerCoupons(key, mapServiceUrls(urls), accessKey, uid), {enabled: !!accessKey && !!urls && !!uid, staleTime: 1000*5*60, retry: false})
    const coupons = data ? data.data : undefined
    return {status, coupons, error, refetch }
}